module.exports = __webpack_public_path__ + "img/ben-pro.99278cba.jpg";